import yup from 'src/libraries/validator.library';
import { FlightOperatorShape } from './flight-operator.model';
import { PilotShape } from './pilot.model';

const OperatorPilotShape = {
  opId: yup.number().required(),
  Operator: yup
    .object()
    .shape({ ...FlightOperatorShape })
    .nullable(),
  Pilot: yup
    .object()
    .shape({
      pilotId: yup.number(),
      ...PilotShape,
    })
    .nullable(),
};

export const OperatorPilotSchema = yup
  .object()
  .shape({
    ...OperatorPilotShape,
  })
  .defined();

export const OperatorPilotListSchema = yup
  .object({
    count: yup.number(),
    rows: yup
      .array()
      .of(
        yup
          .object()
          .shape({
            ...OperatorPilotShape,
          })
          .defined()
      )
      .defined(),
  })
  .defined();

export const OperatorPilotFormSchema = yup
  .object({
    operatorId: yup.number().required(),
    pilotId: yup.number().required(),
  })
  .defined();

export const OperatorPilotResponsePayloadSchema = yup
  .object({
    operatorPilot: yup
      .object({
        opId: yup.number(),
        operatorId: yup.number(),
        pilotId: yup.number(),
      })
      .defined(),
  })
  .defined();

export type IOperatorPilot = yup.InferType<typeof OperatorPilotSchema>;
export type IOperatorPilotList = yup.InferType<typeof OperatorPilotListSchema>;
export type IOperatorPilotForm = yup.InferType<typeof OperatorPilotFormSchema>;
